enum CredOneRequirementStatus {
  PASSED,
  FAILED,
  MISSING,
}
export { CredOneRequirementStatus };
